import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Edit } from 'jbc-front/components/icons';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { Grid } from '@/components/ui/Grid';
import { Dd, Dl, Dt } from '@/components/ui/DefinitionList';
import { displayFormat } from '@/components/utils/formatter';
import { ViewProps } from './ViewProps';

export const Office: FC<ViewProps> = ({ result, editLink }) => {
  return (
    <Panel>
      <Link to={`${editLink}#office`}>
        <Headding icon={<Edit icon={16} />}>適用事業所</Headding>
      </Link>
      <Item>
        <Grid>
          <Dl>
            <Dt>事業所の名称</Dt>
            <Dd>{displayFormat(result.office?.name)}</Dd>
          </Dl>
        </Grid>
      </Item>
    </Panel>
  );
};
